import { render, staticRenderFns } from "./s04.vue?vue&type=template&id=15928430"
import script from "./s04.vue?vue&type=script&lang=js"
export * from "./s04.vue?vue&type=script&lang=js"
import style0 from "./s04.vue?vue&type=style&index=0&id=15928430&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports